import { provideEnvironmentNgxMask, IConfig } from 'ngx-mask';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

export const provideNgxMaskConfig = provideEnvironmentNgxMask(maskConfig);
